/** HTML фото в тексте договора: data URI / URL → тот же wrap, что wrapPhotoElement. */

export function photoHtmlFromValue(value: string): string {
    const v = (value ?? "").trim()
    if (!v) {
        return ""
    }
    if (/<img\b/i.test(v)) {
        return v
    }
    if (isStandalonePhotoSrc(v)) {
        return `<div style="max-width: 80%; margin-left: auto; margin-right: auto; display: block; margin-bottom: 15px; page-break-inside: avoid;"><img style="max-width: 100%; max-height: 450px; width: auto; height: auto; margin-left: auto; margin-right: auto; display: block; page-break-inside: avoid; border-radius: 10px" src="${v}" alt="Фото"/></div>`
    }
    return v
}

export function isFilledPhotoValue(value: unknown): boolean {
    return typeof value === "string" && value.trim().length > 0
}

export function photoSrcFromValue(value: unknown): string | null {
    if (typeof value !== "string") {
        return null
    }
    const v = value.trim()
    if (!v) {
        return null
    }
    const fromImg = v.match(/<img\b[^>]*\bsrc\s*=\s*["']([^"']+)["']/i)
    if (fromImg?.[1]) {
        return fromImg[1]
    }
    return isStandalonePhotoSrc(v) ? v : null
}

/** Inner HTML чипа `name="<<keyword>>"` в body, если там есть картинка. entities после подписания пустые. */
export function photoInnerHtmlFromBody(body: string, keyword: string): string {
    if (!body || !keyword) {
        return ""
    }
    for (const name of [`<<${keyword}>>`, `&lt;&lt;${keyword}&gt;&gt;`]) {
        const inner = innerHtmlOfNamedChip(body, name)
        if (photoSrcFromValue(inner) || /<img\b/i.test(inner)) {
            return inner
        }
    }
    return ""
}

export function displayPhotoValue(entityValue: unknown, body?: string, keyword?: string): string {
    if (isFilledPhotoValue(entityValue)) {
        return String(entityValue).trim()
    }
    if (body && keyword) {
        return photoInnerHtmlFromBody(body, keyword)
    }
    return ""
}

export function hydratePhotoEntityValue(entity: any, body?: string): any {
    if (entity?.type !== "Фото" || isFilledPhotoValue(entity?.value)) {
        return entity
    }
    const fromBody = photoInnerHtmlFromBody(body ?? "", entity.keyword)
    if (!fromBody) {
        return entity
    }
    return {...entity, value: fromBody}
}

function isStandalonePhotoSrc(v: string): boolean {
    return (
        v.startsWith("data:image")
        || v.startsWith("http://")
        || v.startsWith("https://")
        || v.startsWith("/contract-photos/")
    )
}

function indexOfTag(body: string, needle: string, from: number): number {
    const re = new RegExp(needle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig")
    re.lastIndex = from
    const match = re.exec(body)
    return match ? match.index : -1
}

function isTagOpenAt(body: string, index: number, tag: string): boolean {
    const prefix = `<${tag.toLowerCase()}`
    const head = body.slice(index, index + prefix.length + 1).toLowerCase()
    if (!head.startsWith(prefix)) {
        return false
    }
    const after = body.charAt(index + prefix.length)
    return after === "" || after === " " || after === "\t" || after === "\n" || after === "/" || after === ">"
}

function findMatchingClose(body: string, from: number, tag: string): number {
    const closeTok = `</${tag}>`
    const openTok = `<${tag}`
    let depth = 1
    let pos = from
    while (pos < body.length && depth > 0) {
        const nextOpen = indexOfTag(body, openTok, pos)
        const nextClose = indexOfTag(body, closeTok, pos)
        if (nextClose < 0) {
            return -1
        }
        if (nextOpen >= 0 && nextOpen < nextClose && isTagOpenAt(body, nextOpen, tag)) {
            depth += 1
            pos = nextOpen + openTok.length
            continue
        }
        depth -= 1
        if (depth === 0) {
            return nextClose
        }
        pos = nextClose + closeTok.length
    }
    return -1
}

function innerHtmlOfNamedChip(body: string, name: string): string {
    const needle = `name="${name}"`
    let idx = body.indexOf(needle)
    while (idx !== -1) {
        const openStart = body.lastIndexOf("<", idx)
        if (openStart < 0) {
            idx = body.indexOf(needle, idx + needle.length)
            continue
        }
        const tagMatch = body.slice(openStart, openStart + 10).match(/^<(div|span)\b/i)
        const tag = (tagMatch?.[1] ?? "div").toLowerCase()
        const gt = body.indexOf(">", idx)
        if (gt < 0) {
            return ""
        }
        let close = findMatchingClose(body, gt + 1, tag)
        if (close < 0) {
            close = body.indexOf(`</${tag}>`, gt + 1)
        }
        if (close < 0) {
            return ""
        }
        const inner = body.slice(gt + 1, close).trim()
        if (inner) {
            return inner
        }
        idx = body.indexOf(needle, idx + needle.length)
    }
    return ""
}
